// import { CardMedia } from "@mui/material";

// export default function VideoCard({ video }) {
//   return (
//       <CardMedia
//         component="video"
//         src={video}
//         controls
//         sx={{
//           width: "100%",
//           borderRadius: 2,
//           "@media(max-width:768px)":{
//             width: "90%",
//           }
//         }}
//       />
//   );
// }

import { useRef, useEffect } from "react";
import { CardMedia } from "@mui/material";

const VideoCard = ({ video }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;

    // Try autoplay initially
    const playPromise = vid.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          vid.muted = false; // unmute if allowed
        })
        .catch(() => {
          console.log("Autoplay with sound blocked. Click to play.");
        });
    }

    const handleClick = () => {
      vid.muted = false;
      vid.play();
    };
    document.body.addEventListener("click", handleClick, { once: true });

    // Intersection Observer to pause/play on scroll
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          vid.play().catch(() => {});
        } else {
          vid.pause();
        }
      },
      { threshold: 0.5 } // video is considered visible if 50% is in viewport
    );

    observer.observe(vid);

    return () => {
      document.body.removeEventListener("click", handleClick);
      observer.disconnect();
    };
  }, []);

  return (
    <CardMedia
      component="video"
      ref={videoRef}
      src={video}
      autoPlay
      muted
      loop
      playsInline
      sx={{
        width: "100%",
        borderRadius: 2,
        "@media(max-width:768px)": {
          width: "90%",
        },
      }}
    />
  );
};

export default VideoCard;
